export const INFORMATIONAL = {
  label: 'For Informational Purposes Only.',
  value: 'INFORMATIONAL'
};

export const LOWCHARGE = {
  label: 'Low Charge.',
  value: 'LOW_CHARGE'
};
